import { UnlockOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Tooltip } from 'antd';
import React from 'react';
import { CompanyUserProfile } from '../../models/company-user-profile-interface';
import { UserQueries } from '../../queries/user-queries';

interface LockedAccountAlertProps {
  user: CompanyUserProfile | undefined;
  isLoading: boolean;
}

export default function LockedAccountAlert({
  user,
  isLoading,
}: LockedAccountAlertProps) {
  const unlockAccountMutation = UserQueries.useUnlockAccount();

  if (!user || !user.isAccountLocked) return null;

  return (
    <Col span={24}>
      {user.isAccountLocked && (
        <Alert
          type='warning'
          showIcon
          action={<Tooltip overlay='Unlock user account'>
          <Button
            icon={<UnlockOutlined />}
            type='primary'
            disabled={isLoading}
            loading={unlockAccountMutation.isLoading}
            onClick={async () =>
              await unlockAccountMutation.mutateAsync({
                username: user.emailAddress,
                userId: user.userId,
              })
            }
            style={{ marginLeft: 10 }}
          >
            Unlock
          </Button>
        </Tooltip>}
          message={
            <span>
                This user account is currently locked for{' '}
                <b>{`${user.accountLockMinutes} ${
                  user.accountLockMinutes === 1 ? 'minute' : 'minutes'
                }`}</b>{' '}
                after <b>{`${user.failedSignInAttempts} failed login`}</b>{' '}
                attempts.
              </span>
          }
        />
      )}
    </Col>
  );
}
